import client from '../../services/client';

export const forgotPassword = (email) => client.post('forgot_password', { email })
  .then((response) => response.data);
